import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { initTheme, onThemeChange } from "@/lib/theme";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BusinessDetail from "@/pages/BusinessDetail";
import Travel from "@/pages/Travel";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-loading">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
};

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("lbd-theme") || "dark");
  useEffect(() => {
    initTheme();
    return onThemeChange(setTheme);
  }, []);
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/business/:slug" element={<ProtectedRoute><BusinessDetail /></ProtectedRoute>} />
            <Route path="/travel" element={<ProtectedRoute><Travel /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
